import React, { useState } from 'react';
import PropType from 'prop-types';
import styled from 'styled-components';
import { colors } from '../../../ui/common';
import Toggle from './Toggle';

const Wrap = styled.div`
  border-bottom: 1px solid ${colors.color09};
  border-top: 1px solid ${colors.color09};
  margin-top: -1px;
`;
const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 22px 0;
  box-sizing: border-box;
  color: ${colors.color06};
  font-weight: 600;
  font-size: 16px;
`;

const Body = styled.div`
  max-height: ${(props) => (props.active ? 'none' : 0)};
  overflow: ${(props) => (props.active ? 'auto' : 'hidden')};
`;

function Roll({ title, children, startExpanded }) {
  const [active, setActive] = useState(startExpanded);
  return (
    <Wrap>
      <Row>
        <div>{title}</div>
        <Toggle onClick={() => setActive(!active)} active={active} />
      </Row>
      <Body active={active}>{children}</Body>
    </Wrap>
  );
}
export default Roll;

Roll.propTypes = {
  title: PropType.node,
  children: PropType.node,
  startExpanded: PropType.bool,
};

Roll.defaultProps = {
  title: null,
  children: null,
  startExpanded: true,
};
